import React, { useState } from 'react';
import styled from '@emotion/styled';
import {
  Canvas,
  useUndo,
  DrawMode,
  DrawTool,
  ColorBitMapRender,
  bitMap2Base64,
} from '@/src/components/canvas';
import { Palette } from '@/src/components/canvas/Palette';
import {
  Switch,
  Radio,
  Button,
  Modal,
  message,
} from 'antd';
import { Color } from '@/src/components/canvas/bitmap';
import { useEditorContext } from '@/src/context/EditorContext';
import { useCopyToClipboard } from 'react-use';
import { ToolBar } from './ToolBar';

export function BlockEditor() {
  const {
    activeBitMapID,
    options,
    colorBitMaps,
  } = useEditorContext();
  const {
    Container,
    CanvasContainer,
  } = S;
  const handleCanvasOperationFinish = useUndo({
    onBitMapChange: map => colorBitMaps.updateById(activeBitMapID, {
      ...colorBitMaps.table.entries[activeBitMapID],
      map,
    })
  });
  return (
    <Container>
      <ToolBar />
      <CanvasContainer>
        <Canvas
          bitMap={colorBitMaps.table.entries[activeBitMapID].map}
          onBitMapChange={map => colorBitMaps.updateById(activeBitMapID, {
            ...colorBitMaps.table.entries[activeBitMapID],
            map,
          })}
          pixelSize={options.get.pixelSize}
          color={options.get.color}
          onOperationFinish={handleCanvasOperationFinish}
          grid={options.get.grid}
          drawMode={options.get.drawMode}
          tool={options.get.tool}
          // onMouseMove={options.set.pos}
        />
      </CanvasContainer>
    </Container>
  );
}
const S = {
  Container: styled.div`
  `,
  CanvasContainer: styled.div`
    margin: 20px;
  `,
}
